<template>
  <div class="content">
    <div class="content-block">
      <div class="search-input" style="margin-bottom: 20px">
        <label class="icon icon-search" for="result-gene"></label>
        <input class="open-popup open-goods" data-popup=".popup-gene-only" type="search" id='result-gene' placeholder='查询基因...' readonly unselectable="on"/>
      </div>
      <div class="buttons-row">
        <a href="#tab-detail" class="tab-link button active">Detail</a>
        <a href="#tab-comments" class="tab-link button">Comments(123)</a>
      </div>
      <div class="tabs">
        <div class="tab active" id="tab-detail">
          <h3>真正</h3>
          <p>只有当你接触到床的那一刻，才会被前所未有的柔软打动。天丝般的爽滑质感，完美的设计，漂亮的色彩搭配。</p>
          <p><img src="//img.alicdn.com/imgextra/i4/238126515/TB25x8rdXXXXXaWXXXXXXXXXXXX_!!238126515.jpg" alt="" style="width:100%"></p>
          <h3>活性色彩，我的正能量</h3>
          <p>活性印刷，生活不在一成不变，跟上时代的脚步。A版大花纹，古典大气，民族的就是最美。零压力的舒适感，让人完美享受美好的床上时光。</p>
          <p><img src="//img.alicdn.com/imgextra/i3/238126515/TB2ht8qdXXXXXbmXXXXXXXXXXXX_!!238126515.jpg" alt="" style="width:100%"></p>
        </div>
        <div class="tab" id="tab-comments">
          <div class="list-block media-list">
            <ul>
              <li>
                <div class="item-content">
                  <div class="item-media"><img src="http://gqianniu.alicdn.com/bao/uploaded/i4//tfscom/i3/TB10LfcHFXXXXXKXpXXXXXXXXXX_!!0-item_pic.jpg_250x250q60.jpg" width="44"></div>
                  <div class="item-inner">
                    <div class="item-title-row">
                      <div class="item-title">张**三</div>
                      <div class="item-after">12/12 13:11</div>
                    </div>
                    <div class="item-text">聚划算买的，只要888，料子很舒服。</div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import EMKT from '../../emkt.js'

  export default {
    mounted () {
      this.fetchData()
    },
    created () {
    },
    data () {
      return {
        merchandises: ''
      }
    },
    methods: {
      fetchData () {
        this.gcapi('getMerchandiseDetails', '040616fe-68a0-4dec-998b-eaa8f632ebef').then((response) => {
          this.merchandises = response.body.result
        })
      }
    },
    computed: {
      merchandisesMeta () {
        let data = this.merchandises
        let attr = data.attributes
        let dicMeta = EMKT.getEmktMetaData().dictionariesMap
        let attrMeta = EMKT.getEmktMetaData().categoryAttrsMap
        if (data.attributesMeta === undefined) {
          let id = data.categoryId
          let typeTar
          let attributesMeta = {}
          // get
          for (var i in data.attributes) {
            let attrName = i
            let attrVal
            let optTar = {}
            let attrValTar = attrMeta[id + '_' + attrName]
            typeTar = attrMeta[data.categoryId + '_' + attrName].semanticDT
            if (typeTar === 3) {
              let dicValue = dicMeta[attrValTar.extras.substring(11, attrValTar.length)]
              for (var a in dicValue) {
                let val = dicValue[a]
                optTar[val.dictKey] = val.dictValue
              }
              attrVal = {
                'value': attr[attrName],
                'sdType': typeTar,
                'options': optTar
              }
            } else {
              attrVal = {
                'value': attr[attrName],
                'sdType': typeTar
              }
            }
            attributesMeta[attrName] = attrVal
//            console.log(attributesMeta)
          }
          data['attributesMeta'] = attributesMeta
        }
        return data
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DataMeta.vue?61d036cf